export default "__VITE_ASSET__BZEBeMzn__"